import { useState } from "react";
import { toast } from "@volca/ui/lib/toast";
import { useApi } from "@/core/api";
import { reportError } from "@/profitability/utils";
import { fetchDownloadUrl } from "./query";

/**
 * Downloads a document's original file: asks the API for a short-lived link
 * and follows it. The link is an attachment, so the page stays where it is.
 */
export const useDocumentDownload = (businessId: string, documentId: string) => {
  const api = useApi();
  const [downloading, setDownloading] = useState(false);
  const download = async () => {
    setDownloading(true);
    try {
      const { url, file_name } = await fetchDownloadUrl(
        api,
        businessId,
        documentId,
      );
      const link = window.document.createElement("a");
      link.href = url;
      link.download = file_name;
      link.rel = "noopener";
      link.click();
    } catch (error) {
      toast.error("The file could not be downloaded", {
        description: reportError(error),
      });
    } finally {
      setDownloading(false);
    }
  };
  return { download: () => void download(), downloading };
};
